import React, { useState } from 'react'
import { TableRow } from './tableRow'

interface IProps {
    productInfo?: ProductData
}
export function ProductAssetInfo({ productInfo }: IProps): JSX.Element {
    const [isSelected, setIsSelected] = useState(false)

    const productName = productInfo?.productName

    return (
        <React.Fragment>
            <TableRow
                assetName={productName}
                secondaryInfo={productInfo.productId}
                date={productInfo.lastUpdateTimestamp}
                author={productInfo.lastUpdateAuthor}
                productImageId={productInfo.productImageId}
                isSelected={isSelected}
                setIsSelected={setIsSelected}
                rowType={'product'}
            />

            {isSelected
                ? productInfo.SKUs.map(skuInfo => {
                      const childName = skuInfo.skuName

                      return (
                          <TableRow
                              key={productInfo?.productName}
                              assetName={childName}
                              secondaryInfo={skuInfo.skuId}
                              date={skuInfo.lastUpdateTimestamp}
                              author={skuInfo.lastUpdateAuthor}
                              skuColor={skuInfo?.skuColor}
                              isSelected={isSelected}
                              setIsSelected={setIsSelected}
                              rowType={'sku'}
                              productName={productName}
                          />
                      )
                  })
                : null}
        </React.Fragment>
    )
}
